module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.woff2";